import { render, staticRenderFns } from "./dog-request-orders-container.vue?vue&type=template&id=a7faf700&scoped=true&lang=pug"
import script from "./dog-request-orders-container.js?vue&type=script&lang=js&external"
export * from "./dog-request-orders-container.js?vue&type=script&lang=js&external"
import style0 from "./dog-request-orders-container.vue?vue&type=style&index=0&id=a7faf700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7faf700",
  null
  
)

export default component.exports